export default {
	sec_01: {
		title: {
			one: '始め',
			two: 'ま',
			three: 'しょう',
		},
		desc: {
			one: 'すべてはビジネスアカウントから始まります。',
			two: 'JP WORLD PAYを利用する3,000万人以上の販売者と一緒に。',
		},
		btn: {
			one: '会員登録',
			two: '営業チームに問い合わせ',
		},
	},
	sec_14: {
		btn: '始めるためにアカウントの専門家にお問い合わせてください',
	},
	sec_04: {
		title: {
			one: 'シンプルな設定',
		},
		desc: {
			one: 'お問い合わせください。 お手伝い致します。',
		},
		cards: {
			one: {
				title: {
					one: '参加は無料です。',
				},
				description: {
					one: 'メールアドレスとビジネスに',
					two: '関するいくつかの基本的な情報をご用意ください。',
				},
				btn: 'ビジネスアカウントに登録 ',
			},
			two: {
				title: {
					one: 'サービス開始',
				},
				description: {
					one: 'メールアドレスと会社名を確認して、',
					two: 'JP WORLD PAYアカウントを接続すると、',
					three: '最初の販売準備が',
					four: '完了します。',
				},
			},
		},
		btn: 'JP WORLD Pay',
	},
};
